// src/components/directorProfile/StepDirectorTeamMembers.jsx
import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { useFieldArray } from 'react-hook-form';
import { FaPlus, FaTimes } from 'react-icons/fa';
import FormInput from '../../form/FormInput';
import FormSelect from '../../form/FormSelect';

const StepDirectorTeamMembers = ({ control, errors, lookupOptions }) => {
    const { fields, append, remove } = useFieldArray({ control, name: "teamMembers" });

    return (
        <div className="animate-fade-in">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <div className="form-section-title mb-0 border-0">Team / Point of Contact</div>
                <Button variant="outline-danger" size="sm" onClick={() => append({ name: '', email: '', mobile: '', designation: '', contactType: '' })}><FaPlus /> Add Member</Button>
            </div>
            {fields.map((field, index) => (
                <div key={field.id} className="location-box mb-4 p-4 border border-secondary rounded bg-dark position-relative">
                    <div className="d-flex justify-content-between mb-3">
                        <span className="badge bg-danger">Member #{index + 1}</span>
                        {fields.length > 1 && <Button variant="link" className="text-danger p-0" onClick={() => remove(index)}><FaTimes size={18} /></Button>}
                    </div>
                    <Row>
                        <Col md={6}><FormInput name={`teamMembers.${index}.name`} label="Name" control={control} errors={errors} isRequired /></Col>
                        <Col md={6}><FormInput name={`teamMembers.${index}.email`} label="Email" type="email" control={control} errors={errors} isRequired /></Col>
                    </Row>
                    <Row>
                        <Col md={4}><FormInput name={`teamMembers.${index}.mobile`} label="Mobile" control={control} errors={errors} isRequired /></Col>
                        <Col md={4}><FormSelect name={`teamMembers.${index}.designation`} label="Designation" control={control} errors={errors} options={lookupOptions.pocDesignation} isRequired /></Col>
                        <Col md={4}><FormSelect name={`teamMembers.${index}.contactType`} label="Contact Type" control={control} errors={errors} options={lookupOptions.pocContactType} isRequired /></Col>
                    </Row>
                </div>
            ))}
        </div>
    );
};

export default StepDirectorTeamMembers;